/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import o from"../../config.js";import r from"../../core/Error.js";import{supportsApiKey as p}from"../../support/apiKeyUtils.js";function i(i){if(o.apiKey&&p(i.portal.url))throw new r("save-api-key-utils:api-key-not-supported",`Saving is not supported on ${i.portal.url} when using an api key`)}export{i as validateSaveAPIKey};
